import React, { useEffect } from 'react'
import { fetchLmsCourses } from '../../actions'
import { useStateValue } from '@State'

export const CanvasReview = () => {
  const [state, dispatch] = useStateValue()

  useEffect(() => {
    fetchLmsCourses(dispatch)
  }, [])

  const { coursenum, courseTitle, courseList, canvasCoursenum } = state
  let canvasName = ''
  let assessmentsLink = `/instructor/activities/${coursenum}/`

  if (courseList && courseList.length !== 0) {
    let canvasCourseMap = courseList.reduce((memo, c) => {
      memo[c.id] = c
      return memo
    }, {})
    let canvasCourse = canvasCourseMap[canvasCoursenum]
    canvasName = canvasCourse?.name ?? ''
  }

  return (
    <div className="card-myed">
      <div className="canvas-flex-wrapper">
        <div className="wrapper control-box">
          <h3>5. Review</h3>
          <p>
            {courseTitle} is now connected to{' '}
            <span className="bold-span">{canvasName}</span>.
          </p>
          <p>
            Nagivate to your assessments page in MyEducator and select the
            assessments you would like to include in Canvas.
          </p>
          <p>
            Read our{' '}
            <a
              href="https://myeducator.freshdesk.com/support/solutions/articles/14000069099-how-do-i-link-myeducator-to-instructure-canvas-"
              className="faq-link"
            >
              FAQs
            </a>{' '}
            to learn more.
          </p>
          <p>
            This will automatically create corresponding assessments in
            Canvas. Student grades will be updated in Canvas automatically as
            they are completed in MyEducator.
          </p>
          <div className="canvas-flex-wrapper center">
            <a
              href={assessmentsLink}
              className="btn btn-myed btn-primary btn-primary-myed"
            >
              Choose Assessments
            </a>
          </div>
        </div>
        <div className="canvas-statusmarker-container">
          <img src="/static/instructor/media/canvas-logo-lms.png" />
        </div>
      </div>
    </div>
  )
}

